import { PageTitle } from '~/@mid_ui/typography/PageTitle'
import { RunningProjectsTable } from './RunningProjectsTable'

function RunningProjects() {
  return (
    <div className="bg-foreground text-background">
      <PageTitle>Otvorené príležitosti</PageTitle>

      <RunningProjectsTable />
    </div>
  )
}

export { RunningProjects }
